import { __rest } from 'tslib';
import React__default from 'react';
import { SvgImg } from '../svgImg/svgImg.js';

function idify(title) {
    return (title || '').replace(/ /gi, '-');
}
const SvgIcon = (_a) => {
    var { viewbox, title, fill = '#828282', stroke = 'none', strokeWidth = '1', children = [] } = _a, others = __rest(_a, ["viewbox", "title", "fill", "stroke", "strokeWidth", "children"]);
    return (React__default.createElement(SvgImg, Object.assign({ viewbox: viewbox, title: title, fill: fill, stroke: stroke, strokeWidth: strokeWidth }, others),
        React__default.createElement("g", { id: "Symbols", stroke: stroke, strokeWidth: strokeWidth, fill: "none", fillRule: "evenodd" },
            React__default.createElement("g", { id: idify(title), fill: fill }, children))));
};

export { SvgIcon };
